<template>
  <el-dialog
    v-model="personDialogModel"
    :close-on-click-modal="false"
    :align-center="false"
    :z-index="3020"
    width="92%"
    top="5vh"
    class="catalog-insured-dialog-panel catalog-insured-dialog-panel--main"
    :title="$t('catalogDialogTitlePerson')"
    modal-class="catalog-insured-overlay catalog-insured-overlay--dual"
    :destroy-on-close="true"
    append-to-body
    @closed="onPersonMainClosed"
  >
    <person-edit-dialog
      ref="personForm"
      :editing="false"
      :insert="true"
      :no-redirect="true"
      :catalog-product-id="catalogProductId"
      :catalog-product="selectedProduct"
      :catalog-search-draft="personSearchDraft"
      @close-dialog="closePerson"
      @insert-dialog="onPersonInsert"
      @search-loading="personSearchLoading = $event"
      @reset-search-draft="personSearchDraft = emptyPersonSearchDraft()"
    />
  </el-dialog>

  <CatalogPersonSearchDialog
    v-if="personVisible"
    :model-value="personVisible"
    :z-index="3008"
    v-model:pin="personSearchDraft.pin"
    v-model:doc-series="personSearchDraft.docSeries"
    v-model:doc-number="personSearchDraft.docNumber"
    v-model:search-mode="personSearchDraft.searchMode"
    :loading="personSearchLoading"
    @update:model-value="closePerson"
    @search="triggerPersonSearch"
  />

  <el-dialog
    v-model="companyDialogModel"
    :close-on-click-modal="false"
    width="92%"
    top="5vh"
    class="catalog-insured-dialog-panel"
    :title="$t('catalogDialogTitleCompany')"
    modal-class="catalog-insured-overlay"
    :destroy-on-close="true"
    append-to-body
  >
    <company-list-dialog
      :editing="false"
      :object="null"
      @close-dialog="closeCompany"
      @insert-dialog="onCompanyInsert"
    />
  </el-dialog>
</template>

<script>
import PersonEditDialog from "../Common/Dialogs/PersonEditDialog.vue";
import CompanyListDialog from "../Common/Dialogs/CompanyListDialog.vue";
import CatalogPersonSearchDialog from "./CatalogPersonSearchDialog.vue";
import { buildProdDetailRouteAfterInsert } from "./catalogAgentRequest.js";
import { emptyPersonSearchDraft } from "./catalogPersonSearch.js";

export default {
  name: "CatalogInsuredDialogs",
  components: {
    PersonEditDialog,
    CompanyListDialog,
    CatalogPersonSearchDialog,
  },
  props: {
    personVisible: {
      type: Boolean,
      default: false,
    },
    companyVisible: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:personVisible", "update:companyVisible", "person-inserted", "company-inserted"],
  data() {
    return {
      personSearchDraft: emptyPersonSearchDraft(),
      personSearchLoading: false,
    };
  },
  computed: {
    catalogProductId() {
      const p = this.selectedProduct;
      return p && p.productId != null ? p.productId : null;
    },
    personDialogModel: {
      get() {
        return this.personVisible;
      },
      set(v) {
        this.$emit("update:personVisible", v);
      },
    },
    companyDialogModel: {
      get() {
        return this.companyVisible;
      },
      set(v) {
        this.$emit("update:companyVisible", v);
      },
    },
  },
  methods: {
    triggerPersonSearch() {
      this.$refs.personForm?.searchPersonByPin?.();
    },
    closePerson() {
      this.personSearchDraft = emptyPersonSearchDraft();
      this.personSearchLoading = false;
      this.$emit("update:personVisible", false);
    },
    onPersonMainClosed() {
      this.personSearchDraft = emptyPersonSearchDraft();
      this.personSearchLoading = false;
    },
    closeCompany() {
      this.$emit("update:companyVisible", false);
    },
    onPersonInsert(reqId) {
      this.closePerson();
      this.$emit("person-inserted", reqId);
      const route = buildProdDetailRouteAfterInsert(this.catalogProductId, reqId);
      if (route) {
        this.$router.push(route).catch(() => {});
        return;
      }
      this.$router.push("/policies");
    },
    onCompanyInsert() {
      this.$emit("update:companyVisible", false);
      this.$emit("company-inserted");
    },
  },
};
</script>
